import React from 'react';
import { Grid, TextField } from '@material-ui/core/';
import PhoneNumberInput from '../../components/PhoneNumberInput/index';

const ContactForm = ({ disabled, name, setName, phone, setPhone, setExtension, extension, error, buyerEmail, isTimeProposal }) => {
    
    return (
        <div className='contacts-form'>
            <h4 className='page-subtitle'>Enter Your Contact Information</h4>
            {isTimeProposal ? <div className='contacts-form__items'>
                <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Buyer's Email Address"
                        value={buyerEmail}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        disabled={true}
                        error={!!error}
                        helperText={error}
                        className="contacts-form__disable"
                    />
                    </Grid>
                </Grid>
            </div> : null}
            <div className='contacts-form__items'>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            label="Your Name*"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            disabled={disabled}
                            error={!!error}
                            helperText={error}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <PhoneNumberInput
                                    disabled={disabled}
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField id="extension"
                                    name="extension"
                                    onChange={(e) => setExtension(e.target.value)}
                                    value={extension}
                                    inputProps={{ maxLength: 10 }}
                                    margin="normal"
                                    label="Extension"
                                    disabled={disabled}
                                    pattern="/^[0-9-+()]*$/"
                                    variant="outlined"
                                    className="w-100" />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

export default ContactForm;